import { ImpactType } from '../impact/units';
import { MAX_QUANTITY_DECIMAL_PLACES } from '../impact/validation';

export const getMaxDecimalPlaces = (impactType: ImpactType): number => {
  if (impactType === ImpactType.CARBON_OFFSETS || impactType === ImpactType.CARBON_REMOVAL) {
    return MAX_QUANTITY_DECIMAL_PLACES;
  }
  if (impactType === ImpactType.HABITAT_RESTORATION) {
    return 1;
  }
  return 0;
};
